var map = {
	"./abi.png": "7339",
	"./bp-red.png": "0770",
	"./bp-yellow.png": "f9e8",
	"./charging-plate.png": "131c",
	"./ecg.png": "7b8a",
	"./mtablet.png": "ab9e",
	"./spiro.png": "e4d8",
	"./spo2.png": "9184",
	"./tbi-cuffs.png": "e4a2",
	"./tbi-no-cuffs.png": "b767"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3ef4";